import { createStyles, makeStyles, Theme } from 'ui-components';

import { fontText } from 'common-react';

export default makeStyles((theme: Theme) => createStyles({
  root: {
    marginBottom: 70,
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'center',
    gap: 24,
  },
  currency: {
    whiteSpace: 'nowrap',
  },
  card: {
    width: '100%',
  },
  tableHeader: {
    textAlign: 'center',
    font: fontText('normal', theme.fontSize.xxxl, 48),
    borderBottom: `1px solid ${theme.color.greys[20]}`,
    paddingTop: 24,
    paddingBottom: 16,
    marginBottom: 16,
  },
  columnWrapper: {
    maxWidth: 384,
  },
  productItemCell: {
    verticalAlign: 'top',
    padding: '16px 8px',
    '&:nth-child(2)': {
      minHeight: 108,
    },
    '&:nth-child(3)': {
      minHeight: 143,
      background: theme.color.greys[10],
    },
    '&:nth-child(4)': {
      minHeight: 88,
    },
    '&:nth-child(5)': {
      minHeight: 66,
      background: theme.color.greys[10],
    },
    '&:nth-child(6)': {
      minHeight: 66,
      borderBottomLeftRadius: 8,
    },
    '&:nth-child(7)': {
      padding: '16px 0 24px 0',
      borderBottom: `1px solid ${theme.color.greys[20]}`,
    },
  },
  productItemLabel: {
    display: 'block',
    font: fontText('normal', theme.fontSize.s, 16),
    textTransform: 'uppercase',
    color: theme.color.greys[50],
    marginBottom: 4,
  },
  productItemText: {
    font: fontText('normal', theme.fontSize.s, 18),
    color: theme.color.greys[80],
  },
  depositLimit: {
    '& p, span': {
      display: 'inline',
    },
  },
  productLink: {
    marginBottom: 32,
    display: 'block',
  },
  productOptionHeader: {
    paddingTop: 24,
    paddingBottom: 16,
  },
  emptyHelperCell: {
    padding: 24,
    background: theme.color.greys[20],
    width: 'auto'
  },
  entrepreneurDepositButton: {
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
  }
}), { name: 'IkeOrIkzeDesktop' });
